import { render } from "./importComponent.vue?vue&type=template&id=ea6c0538&scoped=true"
import script from "./importComponent.vue?vue&type=script&lang=js"
export * from "./importComponent.vue?vue&type=script&lang=js"

import "./importComponent.vue?vue&type=style&index=0&id=ea6c0538&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea6c0538"]])

export default __exports__